import React, { useEffect, useState } from "react";
import { Row, Col, Form, Table, Pagination, notification } from "antd";
import UserHeader from "../../components/header/UserHeader";
import UserDrawer from "../../components/drawer/UserDrawer";
import { componentStyles } from "../myProfile/ProfileStyles";
import { componentConversationStyles } from "../myProfile/PreviousConversationsStyles";
import { getBillingHistory } from "../../api/password";
import ClipLoader from "react-spinners/ClipLoader";
import { useNavigate } from "react-router-dom";
import "../onboarding/UserOnboardingPage.css";
import "../myProfile/PreviousConversationsStyle.css";
import eyeIcon from "../../assets/images/eye.svg";
import moment from "moment";

const perPageRecords = 10;

const BillingHistory = () => {
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [loader, setLoader] = useState(true);
    const [payments, setPayments] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [form] = Form.useForm();
    const navigate = useNavigate();

    const fetchData = async (page) => {
        try {
            setLoader(true);
            const response = await getBillingHistory(page, perPageRecords);
            const mappedData = response.payments.map((billing) => ({
                stripePaymentIntentId: billing.stripePaymentIntentId,
                datePaid: moment(billing.datePaid).format("DD-MM-YYYY"),
                amountPaid: billing.amountPaid,
                subscriptionStatus: billing.subscriptionStatus
            }));
            setPayments(mappedData);
            setTotalPages(Math.ceil(response.totalCount / perPageRecords));
        } catch (err) {
            console.error("Error fetching data:", err);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const openDrawer = () => {
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
    };

    const sectionsContainerStyle = {
        transition: "opacity 0.3s ease, pointer-events 0.3s ease",
        opacity: isDrawerOpen ? "0.5" : "1",
        pointerEvents: isDrawerOpen ? "none" : "auto",
    };

    const handleViewInvoice = (record) => {
        navigate(`/invoice`, { state: { stripePaymentIntentId: record.stripePaymentIntentId } });
    };
    
    const columns = [
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Transaction Id</div>,
            dataIndex: 'stripePaymentIntentId',
            key: 'stripePaymentIntentId',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Date Billed</div>,
            dataIndex: 'datePaid',
            key: 'datePaid',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Amount</div>,
            dataIndex: 'amountPaid',
            key: 'amountPaid',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>Status</div>,
            dataIndex: 'subscriptionStatus',
            key: 'subscriptionStatus',
            align: 'center',
        },
        {
            title: <div style={{ backgroundColor: '#F3FDFF' }}>View Invoice</div>,
            key: 'view',
            align: 'center',
            render: (_, record) => (
                <img
                    src={eyeIcon}
                    alt="View"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleViewInvoice(record)}
                />
            ),
        }
    ];

    return (
        <div style={{ minHeight: "100dvh", overflow: "hidden", background: "#fefcfe" }}>
            <Col xs={24} sm={24} lg={24} md={24} style={sectionsContainerStyle}>
                <Row justify={{ xs: "space-around", md: "space-around", lg: "space-between" }} style={{ marginBottom: 20 }}>
                    <Col xs={{ span: 22 }} lg={{ span: 24 }} md={{ span: 22 }}>
                        <UserHeader setDrawer={openDrawer} />
                    </Col>
                    {isDrawerOpen && (
                        <Col span={4}>
                            <UserDrawer isDrawerOpen={isDrawerOpen} onClose={closeDrawer} />
                        </Col>
                    )}
                </Row>
                {loader ? (
                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px" }}>
                        <ClipLoader loading={loader} size={50} aria-label="Loading Spinner" data-testid="loader" />
                    </div>
                ) : (
                    <Form form={form}>
                        <Row justify="center" style={{ padding: "25px" }}>
                            <Col span={20} style={{ paddingLeft: "2%" }}>
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24}>
                                        <Row style={componentStyles.rowStyling}>
                                            <h1 style={componentConversationStyles.headingStyle}>Billing History</h1>
                                        </Row>
                                    </Col>
                                </Row>
                                <Table dataSource={payments} columns={columns} className="centered-table" pagination={false} />
                                <Pagination
                                    current={currentPage}
                                    pageSize={perPageRecords}
                                    total={totalPages * perPageRecords}
                                    onChange={handlePageChange}
                                    style={{ marginTop: "40px", textAlign: "right" }}
                                />
                            </Col>
                        </Row>
                    </Form>
                )}
            </Col>
        </div>
    );
};

export default BillingHistory;
